import React, { useState } from 'react';
import { useAuth } from '../../state/auth/useAuth';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/nurse-dashboard/Sidebar';
import DashboardOverview from '../../components/nurse-dashboard/DashboardOverview';
import OPDAdmissions from '../../components/nurse-dashboard/OPDAdmissions';
import PatientQueue from '../../components/nurse-dashboard/PatientQueue';
import VitalSigns from '../../components/nurse-dashboard/VitalSigns';
import Reports from '../../components/nurse-dashboard/Reports';
import Emergency from '../../components/nurse-dashboard/Emergency';
import PatientNotes from '../../components/nurse-dashboard/PatientNotes';
import BedManagement from '../../components/nurse-dashboard/BedManagement';
import NavigationPreventer from '../../components/NavigationPreventer';

const NurseDashboard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const renderTabContent = () => {
    switch(activeTab) {
      case 'dashboard':
        return <DashboardOverview />;
      case 'opd-admissions':
        return <OPDAdmissions />;
      case 'patient-queue':
        return <PatientQueue />;
      case 'patient-care':
        return (
          <div className="text-center py-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Patient Care</h2>
            <p className="text-gray-600">Patient care management features coming soon...</p>
          </div>
        );
      case 'vital-signs':
        return <VitalSigns />;
      case 'visits':
        return (
          <div className="text-center py-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Visits & Checkups</h2>
            <p className="text-gray-600">Visit management features coming soon...</p>
          </div>
        );
      case 'bed-management':
        return <BedManagement />;
      case 'patient-notes':
        return <PatientNotes />;
      case 'reports':
        return <Reports />;
      case 'emergency':
        return <Emergency />;
      case 'settings':
        return (
          <div className="text-center py-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Settings</h2>
            <p className="text-gray-600">System settings coming soon...</p>
          </div>
        );
      default:
        return <DashboardOverview />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <NavigationPreventer />
      {/* Sidebar */}
      <Sidebar 
        activeTab={activeTab} 
        setActiveTab={setActiveTab}
        onLogout={handleLogout}
      />
      
      {/* Main Content */}
      <div className="flex-1 overflow-hidden">
        <div className="h-full overflow-y-auto">
          <div className="p-8">
            {renderTabContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NurseDashboard;
